import { render } from "./TaskTag.vue?vue&type=template&id=6925c765"
import script from "./TaskTag.vue?vue&type=script&lang=js"
export * from "./TaskTag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__